<div class="card mb-3">
  <div class="card-body">
    <h1>Notes</h1>
    <div id="water-system-notes">
      <div class="pt-3">
        <app-notes [notes]="notes" [relatedItem]="'watersystem'"></app-notes>
      </div>
    </div>
  </div>
</div>